import { render, staticRenderFns } from "./RegionReference.vue?vue&type=template&id=62ebe7c4"
import script from "./RegionReference.vue?vue&type=script&lang=js"
export * from "./RegionReference.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports